export const formatDate = (dateString: string): string => {
  return new Date(Date.parse(dateString))?.toLocaleDateString('en-US', {
    weekday: 'long',
    day: 'numeric',
    month: 'short'
  })
}

export const getUserFullName = (userAttributes: any): string => {
  return `${userAttributes.given_name as string} ${userAttributes.family_name as string}`
}

export const formatPercent = (value: number | unknown): string => {
  if (typeof value !== 'number') return 'N/A'
  return `${Math.round(value * 100)}%`
}

export const formatNumber = (value?: number | unknown): any => {
  if (typeof value !== 'number') return null
  return value % 1 === 0 ? value.toString() : value.toFixed(2).replace(/\.?0+$/, '')
}
